import axios from 'axios/index'
import VueCookie from 'vue-cookie'
import { authByLoginPassword } from "./authserv";
import store from '@/store'
/* eslint-disable no-unused-vars */
export const Api = axios.create({
  withCredentials: window.x2.authType === 'cookie',
  defaults: {
    headers: {
      post: {
        'Content-Type': 'application/json'
      }
    }
  }
})

const ApiMultipart = axios.create({
  withCredentials: window.x2.authType === 'cookie',
  defaults: {
    headers: {
      post: {
        'Content-Type': 'multipart/form-data'
      }
    }
  }
})

Api.interceptors.request.use(config => {
  if (Object.prototype.hasOwnProperty.call(window.x2, 'additionalHeaders') && Object.keys(window.x2.additionalHeaders).length > 0) {
    window.x2.additionalHeaders.map((item) => { config.headers[item] = window.x2.additionalHeaders[item] })
  }
  if (window.x2.auth === 'bearer') {
    const token = VueCookie.get('x-token')
    if (token) {
      config.defaults.headers.common['Authorization'] = 'Bearer ' + token
    }
  }
  return config
})

Api.interceptors.response.use(
  response => {
    return response
  },
  async function (error) {
    if (error.response.status === 403 || error.response.status === 401) {
      const originalRequest = error.config
      store.commit('setToken', '')
      VueCookie.delete('x2-auth-state')
      const cr = localStorage.credentials
      if (cr) {
        await apiQuery('public', 'authenticate', JSON.parse(cr), false)
          .then(response => {
            VueCookie.set('x2-auth-state', 'authorized', { expires: '1h' })
            store.commit('setToken', 'authorized')
            return Api(originalRequest)
          }).catch(error => {
            return error
          })
      }
    }
    return Promise.reject(error.response)
  }
)

export const apiRoot = (process.env.NODE_ENV === 'production' ? window.x2.url : ''  ) + window.x2.api

export function apiQuery (area, method, data = {}, sendContext = true) {
  let params = {
    method: method,
    params: data
  }
  if (sendContext && Object.keys(store.getters.context).length > 0) {
    params.context = { state: store.getters.context }
  }
  return Api.post(apiRoot + area + '?action=' + method, params).then(response => {
    if (response.data.status === 'ok') {
      return Promise.resolve(response.data.result)
    } else {
      return Promise.reject(response.data.message)
    }
  }).catch(error => Promise.reject(error.data))
}

export function apiUpload (uri, data) {
  return ApiMultipart.post(apiRoot + uri, data)
}

export function auth (login, password) {
  if (window.x2.auth === 'api') {
    return apiQuery('public', 'authenticate', {username: login, password: password}, false)
  } else if (window.x2.auth === 'authsrv') {
    return authByLoginPassword(login, password)
  }
}
